import styled from 'styled-components';

export const StyledTimeline = styled.div`
  border-color: var(--ion-color-light-shade);
  border-style: double;
`;
